import { Injectable } from '@angular/core';

import { AbstractToolService } from './abstract-tool.service';
import { DataModelService } from '../services/data-model.service';
import { DesignHostContainer, LayoutControlContainer, ControlDataModel } from '../types';
import { clearControlIdentityCode } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class CopyToolService extends AbstractToolService {
  private _source: DesignHostContainer;

  constructor(protected dataModelService: DataModelService) {
    super();
  }

  start(source: DesignHostContainer) {
    this._source = source;
  }

  do(host: LayoutControlContainer, args: any) {
    if (host.control.isContainer) {
      const dataModel = this._source.control.getDataModel();
      clearControlIdentityCode(dataModel);
      const layoutModel = this.dataModelService.translateDataModel2LayoutModel(dataModel);

      if (host.control.addControl) {
        host.control.addControl(layoutModel);
      }
      super.raiseCompletedEvent(args);
    }
  }
}
